import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { Box, Toolbar } from '@mui/material';

import Home from './pages/Home';
import Research from './pages/Research';
import Members from './pages/Members';
import Publications from './pages/Publications2';
import Gallery from './pages/Gallery';

const MainContentWrapper: React.FC = () => {
  const location = useLocation();

  return (
    <Box>
      {location.pathname !== '/' && <Toolbar />} {/* Home 페이지가 아닐 때만 Toolbar 스페이서 추가 */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/research" element={<Research />} />
        <Route path="/publications" element={<Publications />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/members" element={<Members />} />
      </Routes>
    </Box>
  );
};

export default MainContentWrapper;